import { useNavigate } from "react-router-dom";
import CustomButton from "../../../components/form/CustomButton";
import FileUploader from "./FileUploader";

const StepThree = ({
  validation,
  setModalPrev,
  deleteItem,
  onBack,
  onSave,     // función que va a guardar el load completo
  onCancel,   // opcional, si quieres manejar cancel desde el padre
  loading
}) => {
  const navigate = useNavigate();

  const cancelLoad = () => {
    if (onCancel) {
      onCancel();
    } else {
      navigate("/loads");
    }
  };

  return (
    <>
      {/* Contenido principal del paso */}
      <div className="space-y-4">
        <h2 className="text-lg font-semibold text-cs-dark">
          Documents & evidence (optional)
        </h2>
        <p className="text-sm text-cs-muted">
          Upload documents related to this load if available: rate confirmations, POD, photos
          and internal notes.
        </p>

        <div
          className="
            bg-cs-bg border border-cs-border rounded-2xl
            shadow-sm px-3 md:px-4 py-3 md:py-4
          "
        >
          <FileUploader
            validation={validation}
            setModalPrev={setModalPrev}
            deleteItem={deleteItem}
          />
        </div>
      </div>

      {/* Footer navegación del paso 3 */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mt-6 pt-4 border-t border-cs-border">
        <div className="text-xs text-cs-muted">
          Step 3 of 3 – Optional documents before finishing.
        </div>

        <div className="flex justify-end gap-3">
          <CustomButton
            type="button"
            onClick={cancelLoad}
            loading={loading}
            textLoad={"Cancel"}
            className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              bg-cs-danger hover:bg-cs-primary-hover
              text-white text-sm font-medium
              shadow-md hover:shadow-lg
              transition-all
            "
          >
            Cancel
          </CustomButton>

          <CustomButton
            type="button"
            onClick={onBack}
            className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              bg-cs-bg
              border border-cs-border
              text-sm text-cs-dark
              hover:bg-cs-bg-alt
              transition-all
            "
          >
            <span className="material-symbols-outlined text-sm">
              arrow_back
            </span>
            Back
          </CustomButton>

          <CustomButton
            type="button"
            onClick={onSave}
            loading={loading}
            textLoad={"Saving data…"}
            className="
              inline-flex items-center gap-2
              px-4 py-2.5
              rounded-xl
              bg-cs-primary hover:bg-cs-primary-hover
              text-white text-sm font-medium
              shadow-md hover:shadow-lg
              transition-all
            "
          >
            Save load
            <span className="material-symbols-outlined text-sm">
              save
            </span>
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default StepThree;
